var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from "../di/injectable";
var I18N = /** @class */ (function () {
    function I18N() {
    }
    I18N.prototype.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.load()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(I18N.prototype, "language", {
        get: function () { return document.documentElement.lang || 'en'; },
        enumerable: false,
        configurable: true
    });
    I18N.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!this.data) return [3 /*break*/, 1];
                                    resolve();
                                    return [3 /*break*/, 3];
                                case 1: return [4 /*yield*/, this.loadFromFile()];
                                case 2:
                                    _a.sent();
                                    resolve();
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    I18N.prototype.loadFromFile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lang, url, response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        lang = this.language;
                        url = "".concat(window.__webpack_public_path__, "/locales/").concat(lang, ".json");
                        return [4 /*yield*/, fetch(url)];
                    case 1:
                        response = _b.sent();
                        _a = this;
                        return [4 /*yield*/, response.json()];
                    case 2:
                        _a.data = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    I18N.prototype.localized = function (key, dynamicArgs) {
        return this.translate(this.localizedObject(key), dynamicArgs);
    };
    I18N.prototype.localizedObject = function (key) {
        if (key.includes('.')) {
            return this.correctedKey(key);
        }
        return this.data[key];
    };
    I18N.prototype.correctedKey = function (key) {
        var splitted = key.split('.');
        var object = this.data[splitted.shift()];
        while (splitted.length > 0) {
            object = object[splitted.shift()];
        }
        return object;
    };
    I18N.prototype.translate = function (localizedString, dynamicArgs) {
        var result = localizedString;
        if (!dynamicArgs) {
            return result;
        }
        Object.keys(dynamicArgs).forEach(function (key) {
            var value = dynamicArgs[key];
            var regex = new RegExp("{{".concat(key, "}}"), 'g');
            result = result.replace(regex, value);
        });
        return result;
    };
    I18N = __decorate([
        Injectable()
    ], I18N);
    return I18N;
}());
export { I18N };
//# sourceMappingURL=i18n.js.map